import { PlusCircleIcon } from "@heroicons/react/24/solid";
import api from "@src/api/api";
import { User } from "@src/utils/user";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  user: User;
  me: User;
  size?: number;
};

const UserWidget = ({ user, me, ...props }: Props) => {
  const size = (props.size || 50) * 0.7 * 0.7;
  const queryClient = useQueryClient();

  const follow = useMutation([`follow-${me.id}-${user.id}`], {
    mutationFn: async () => {
      const res = await api.get(`/api/v1/users/${user.id}/follow`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["posts"] });
    },
    onError: () => {
      alert("Failed");
    },
  });

  return (
    <PlusCircleIcon
      className="absolute inset-x-0 mx-auto translate-y-1 cursor-pointer rounded-full bg-white font-bold text-red-600 shadow-xl"
      onClick={e => {
        e.preventDefault();
        follow.mutate();
      }}
      style={{
        width: `${size.toString()}px`,
        height: `${size.toString()}px`,
        bottom: `-${size * 0.35}px`,
      }}
    />
  );
};

export default UserWidget;
